/** @jsx jsx */
import { Button, EmptyStateSadSquare, Flex, Heading } from "@eworkit/iris";
import { Loader, Paragraph } from "@eworkit/iris";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

interface FilePreviewMessageProps {
  loading?: boolean;
  heading?: string;
  instruction?: string;
  error?: boolean;
  onDownloadButtonClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const FilePreviewMessage: FC<FilePreviewMessageProps> = ({
  heading,
  instruction,
  error,
  onDownloadButtonClick,
  loading,
}) => {
  const { t } = useTranslation("session");

  return (
    <Flex gap="sm" p="xxl" flexDirection="column" alignItems="center" mt="xxl">
      {loading && <Loader size="xl" />}
      {error && <EmptyStateSadSquare />}
      {heading && <Heading size="h-sm">{heading}</Heading>}
      {instruction && <Paragraph>{instruction}</Paragraph>}
      {onDownloadButtonClick && (
        <Button variant="primary" onClick={onDownloadButtonClick}>
          {t("COMPONENTS.PDF_PREVIEW.DOWNLOAD_FILE")}
        </Button>
      )}
    </Flex>
  );
};
